import classNames from "classnames";
import styles from "./index.module.less";
import { useEffect, useState } from "react";

export default function VipRadio({ checked, onChange, disabled, size }) {
  const [activeChecked, setActiveChecked] = useState(checked);
  const onClick = () => {
    if (disabled) return;
    setActiveChecked(!activeChecked);
    onChange && onChange(!activeChecked);
  };

  useEffect(() => {
    setActiveChecked(checked);
  }, [checked, disabled]);

  return (
    <div
      className={classNames(
        styles.radioCircle,
        { [styles.active]: activeChecked },
        { [styles.radioDisabled]: disabled },
        { [styles[size]]: size }
      )}
      checked={activeChecked}
      onClick={onClick}
    ></div>
  );
}
